'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  cursor: ', ';\n  min-height: 58px;\n  min-width: 232px;\n'], ['\n  cursor: ', ';\n  min-height: 58px;\n  min-width: 232px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _fileAttachmentTypes = require('conversations-schema/common-message-format/constants/fileAttachmentTypes');

var _ImageAttachment = require('./ImageAttachment');

var _ImageAttachment2 = _interopRequireDefault(_ImageAttachment);

var _DocumentAttachment = require('./DocumentAttachment');

var _DocumentAttachment2 = _interopRequireDefault(_DocumentAttachment);

var _VisitorWidgetFileAttachmentPlaceholder = require('./VisitorWidgetFileAttachmentPlaceholder');

var _VisitorWidgetFileAttachmentPlaceholder2 = _interopRequireDefault(_VisitorWidgetFileAttachmentPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'VisitorWidgetFileAttachment__Wrapper'
})(_templateObject, function (_ref) {
  var loading = _ref.loading;
  return loading ? undefined : 'pointer';
});

var VisitorWidgetFileAttachment = function (_React$Component) {
  _inherits(VisitorWidgetFileAttachment, _React$Component);

  function VisitorWidgetFileAttachment() {
    _classCallCheck(this, VisitorWidgetFileAttachment);

    return _possibleConstructorReturn(this, (VisitorWidgetFileAttachment.__proto__ || Object.getPrototypeOf(VisitorWidgetFileAttachment)).apply(this, arguments));
  }

  _createClass(VisitorWidgetFileAttachment, [{
    key: 'renderContent',
    value: function renderContent() {
      var _props = this.props,
          name = _props.name,
          size = _props.size,
          type = _props.type,
          url = _props.url,
          onLoad = _props.onLoad;


      if (type === _fileAttachmentTypes.IMG) {
        return _react2.default.createElement(_ImageAttachment2.default, { name: name, url: url, onLoad: onLoad });
      }

      return _react2.default.createElement(_DocumentAttachment2.default, { name: name, onLoad: onLoad, size: size });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          loading = _props2.loading,
          onClick = _props2.onClick;


      return _react2.default.createElement(
        Wrapper,
        {
          className: (0, _classNames2.default)('display-flex', 'justify-center', className),
          loading: loading,
          onClick: onClick
        },
        this.props.loading ? _react2.default.createElement(_VisitorWidgetFileAttachmentPlaceholder2.default, null) : this.renderContent()
      );
    }
  }]);

  return VisitorWidgetFileAttachment;
}(_react2.default.Component);

VisitorWidgetFileAttachment.propTypes = {
  className: _react.PropTypes.string,
  loading: _react.PropTypes.bool,
  name: _react.PropTypes.string.isRequired,
  onClick: _react.PropTypes.func.isRequired,
  onLoad: _react.PropTypes.func.isRequired,
  size: _react.PropTypes.number.isRequired,
  type: _react.PropTypes.oneOf([_fileAttachmentTypes.IMG, _fileAttachmentTypes.MOVIE, _fileAttachmentTypes.DOCUMENT, _fileAttachmentTypes.AUDIO, _fileAttachmentTypes.OTHER]),
  url: _react.PropTypes.string.isRequired
};

exports.default = VisitorWidgetFileAttachment;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/attachments/VisitorWidgetFileAttachment.js
// module id = 1134
// module chunks = 2 3